// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   OnboardingModal — 첫 로그인 정보수집 (4스텝)
   ProtectedRoute에서 강제 표시. 닫기 불가 (X 버튼 없음, 백드롭 클릭 무시).
   ======================================================================== */

.onboarding-modal__overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  animation: onboardingFade 180ms ease-out;
}

@keyframes onboardingFade {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.onboarding-modal {
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  animation: onboardingSlide 220ms ease-out;
}

@keyframes onboardingSlide {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ─── 헤더 ─── */
.onboarding-modal__head {
  padding: 28px 28px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
  border-bottom: 1px solid var(--fg-line, #e5e7eb);
}

.onboarding-modal__brand {
  width: 48px;
  height: 48px;
  display: grid;
  place-items: center;
  background: var(--fg-button, #7c3aed);
  color: #fff;
  font-weight: 800;
  font-size: 16px;
  letter-spacing: -0.5px;
  border-radius: 12px;
  margin-bottom: 8px;
}

.onboarding-modal__progress {
  display: inline-flex;
  gap: 8px;
  margin: 4px 0 8px;
}

.onboarding-modal__dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--fg-line, #e5e7eb);
  transition: background 200ms ease, transform 200ms ease;
}

.onboarding-modal__dot--active {
  background: var(--fg-button, #7c3aed);
  transform: scale(1.4);
}

.onboarding-modal__dot--done {
  background: var(--fg-button-hover, #6d28d9);
}

.onboarding-modal__title {
  margin: 4px 0 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--fg-text-basic, #111827);
}

.onboarding-modal__subtitle {
  margin: 0;
  font-size: 13px;
  color: var(--fg-text-gray, #6b7280);
}

/* ─── 바디 (스크롤 가능) ─── */
.onboarding-modal__body {
  padding: 20px 28px 12px;
  overflow-y: auto;
}

/* 옵션 그리드 */
.onboarding-modal__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.onboarding-modal__grid--cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.onboarding-modal__option {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 16px;
  background: #fff;
  border: 1.5px solid var(--fg-line, #e5e7eb);
  border-radius: 12px;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: var(--transition-fast, all 0.15s ease);
}

.onboarding-modal__option:hover:not(:disabled) {
  border-color: var(--fg-button, #7c3aed);
  background: var(--fg-bg-litepp, #f5f3ff);
}

.onboarding-modal__option--selected {
  border-color: var(--fg-button, #7c3aed);
  background: var(--fg-bg-litepp, #f5f3ff);
}

.onboarding-modal__option:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.onboarding-modal__option-label {
  font-size: 14px;
  font-weight: 700;
  color: var(--fg-text-basic, #111827);
}

.onboarding-modal__option-desc {
  font-size: 12px;
  color: var(--fg-text-gray, #6b7280);
  line-height: 1.4;
}

/* etc 입력 행 (그리드 전체 폭 차지) */
.onboarding-modal__etc {
  grid-column: 1 / -1;
  display: flex;
  gap: 8px;
  margin-top: 4px;
}

/* 소속 입력 스텝 */
.onboarding-modal__org {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}

.onboarding-modal__org .onboarding-modal__input {
  width: 100%;
}

.onboarding-modal__or {
  margin: 4px 0;
  font-size: 13px;
  color: var(--fg-text-gray, #6b7280);
}

/* 입력 */
.onboarding-modal__input {
  flex: 1 1;
  height: 44px;
  padding: 10px 14px;
  background: #fff;
  border: 1.5px solid var(--fg-line, #e5e7eb);
  border-radius: 10px;
  font-family: inherit;
  font-size: 14px;
  color: var(--fg-text-basic, #111827);
  outline: none;
  transition: border-color 160ms ease;
}

.onboarding-modal__input:focus {
  border-color: var(--fg-button, #7c3aed);
}

/* 버튼 */
.onboarding-modal__primary {
  height: 44px;
  padding: 0 18px;
  background: var(--fg-button, #7c3aed);
  color: #fff;
  border: 0;
  border-radius: 10px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 160ms ease;
}

.onboarding-modal__primary:hover:not(:disabled) {
  background: var(--fg-button-hover, #6d28d9);
}

.onboarding-modal__primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.onboarding-modal__ghost {
  height: 36px;
  padding: 0 16px;
  background: transparent;
  color: var(--fg-text-basic, #111827);
  border: 1px solid var(--fg-line, #e5e7eb);
  border-radius: 10px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-fast, all 0.15s ease);
}

.onboarding-modal__ghost:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.03);
  border-color: var(--fg-button, #7c3aed);
  color: var(--fg-button, #7c3aed);
}

.onboarding-modal__ghost:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.onboarding-modal__hint {
  grid-column: 1 / -1;
  margin: 8px 0 0;
  font-size: 12px;
  color: var(--fg-text-gray, #6b7280);
  text-align: center;
}

/* 푸터 */
.onboarding-modal__foot {
  padding: 16px 28px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid var(--fg-line, #e5e7eb);
}

.onboarding-modal__step-count {
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-gray, #6b7280);
}

`, "",{"version":3,"sources":["webpack://./src/css/Onboarding.css"],"names":[],"mappings":"AAAA;;;6EAG6E;;AAE7E;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,eAAe;AACf;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mCAAmC;AACrC;;AAEA,wBAAwB;AACxB;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mCAAmC;AACrC;;AAEA,OAAO;AACP;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,oCAAoC;EACpC,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,OAAO;AACP;EACE,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA,OAAO;AACP;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC","sourcesContent":["/* ========================================================================\n   OnboardingModal — 첫 로그인 정보수집 (4스텝)\n   ProtectedRoute에서 강제 표시. 닫기 불가 (X 버튼 없음, 백드롭 클릭 무시).\n   ======================================================================== */\n\n.onboarding-modal__overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  background: rgba(15, 23, 42, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  animation: onboardingFade 180ms ease-out;\n}\n\n@keyframes onboardingFade {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n.onboarding-modal {\n  width: 100%;\n  max-width: 560px;\n  max-height: calc(100vh - 48px);\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n  animation: onboardingSlide 220ms ease-out;\n}\n\n@keyframes onboardingSlide {\n  from { opacity: 0; transform: translateY(12px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* ─── 헤더 ─── */\n.onboarding-modal__head {\n  padding: 28px 28px 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  text-align: center;\n  border-bottom: 1px solid var(--fg-line, #e5e7eb);\n}\n\n.onboarding-modal__brand {\n  width: 48px;\n  height: 48px;\n  display: grid;\n  place-items: center;\n  background: var(--fg-button, #7c3aed);\n  color: #fff;\n  font-weight: 800;\n  font-size: 16px;\n  letter-spacing: -0.5px;\n  border-radius: 12px;\n  margin-bottom: 8px;\n}\n\n.onboarding-modal__progress {\n  display: inline-flex;\n  gap: 8px;\n  margin: 4px 0 8px;\n}\n\n.onboarding-modal__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: var(--fg-line, #e5e7eb);\n  transition: background 200ms ease, transform 200ms ease;\n}\n\n.onboarding-modal__dot--active {\n  background: var(--fg-button, #7c3aed);\n  transform: scale(1.4);\n}\n\n.onboarding-modal__dot--done {\n  background: var(--fg-button-hover, #6d28d9);\n}\n\n.onboarding-modal__title {\n  margin: 4px 0 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--fg-text-basic, #111827);\n}\n\n.onboarding-modal__subtitle {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fg-text-gray, #6b7280);\n}\n\n/* ─── 바디 (스크롤 가능) ─── */\n.onboarding-modal__body {\n  padding: 20px 28px 12px;\n  overflow-y: auto;\n}\n\n/* 옵션 그리드 */\n.onboarding-modal__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.onboarding-modal__grid--cols-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.onboarding-modal__option {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 14px 16px;\n  background: #fff;\n  border: 1.5px solid var(--fg-line, #e5e7eb);\n  border-radius: 12px;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n  transition: var(--transition-fast, all 0.15s ease);\n}\n\n.onboarding-modal__option:hover:not(:disabled) {\n  border-color: var(--fg-button, #7c3aed);\n  background: var(--fg-bg-litepp, #f5f3ff);\n}\n\n.onboarding-modal__option--selected {\n  border-color: var(--fg-button, #7c3aed);\n  background: var(--fg-bg-litepp, #f5f3ff);\n}\n\n.onboarding-modal__option:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.onboarding-modal__option-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--fg-text-basic, #111827);\n}\n\n.onboarding-modal__option-desc {\n  font-size: 12px;\n  color: var(--fg-text-gray, #6b7280);\n  line-height: 1.4;\n}\n\n/* etc 입력 행 (그리드 전체 폭 차지) */\n.onboarding-modal__etc {\n  grid-column: 1 / -1;\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n/* 소속 입력 스텝 */\n.onboarding-modal__org {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n}\n\n.onboarding-modal__org .onboarding-modal__input {\n  width: 100%;\n}\n\n.onboarding-modal__or {\n  margin: 4px 0;\n  font-size: 13px;\n  color: var(--fg-text-gray, #6b7280);\n}\n\n/* 입력 */\n.onboarding-modal__input {\n  flex: 1;\n  height: 44px;\n  padding: 10px 14px;\n  background: #fff;\n  border: 1.5px solid var(--fg-line, #e5e7eb);\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 14px;\n  color: var(--fg-text-basic, #111827);\n  outline: none;\n  transition: border-color 160ms ease;\n}\n\n.onboarding-modal__input:focus {\n  border-color: var(--fg-button, #7c3aed);\n}\n\n/* 버튼 */\n.onboarding-modal__primary {\n  height: 44px;\n  padding: 0 18px;\n  background: var(--fg-button, #7c3aed);\n  color: #fff;\n  border: 0;\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 160ms ease;\n}\n\n.onboarding-modal__primary:hover:not(:disabled) {\n  background: var(--fg-button-hover, #6d28d9);\n}\n\n.onboarding-modal__primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.onboarding-modal__ghost {\n  height: 36px;\n  padding: 0 16px;\n  background: transparent;\n  color: var(--fg-text-basic, #111827);\n  border: 1px solid var(--fg-line, #e5e7eb);\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition-fast, all 0.15s ease);\n}\n\n.onboarding-modal__ghost:hover:not(:disabled) {\n  background: rgba(0, 0, 0, 0.03);\n  border-color: var(--fg-button, #7c3aed);\n  color: var(--fg-button, #7c3aed);\n}\n\n.onboarding-modal__ghost:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.onboarding-modal__hint {\n  grid-column: 1 / -1;\n  margin: 8px 0 0;\n  font-size: 12px;\n  color: var(--fg-text-gray, #6b7280);\n  text-align: center;\n}\n\n/* 푸터 */\n.onboarding-modal__foot {\n  padding: 16px 28px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid var(--fg-line, #e5e7eb);\n}\n\n.onboarding-modal__step-count {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-gray, #6b7280);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
